<template>
  <v-container pb-0>
    <div class="inline">
      <div class="filter-panel-outer hidden-sm-and-down" ref="filterPanelOuter">
        <!--TODO: add the fixed element in here so that we can get what width it need to be from the parent div-->
        <div class="filter-panel-inner pr-3">
          <search-bar :placeholder="searchBarPlaceholder" :hint="searchBarHint"
                      search-action="SEARCH_LIST_OF_STUDENTS" :search-value="searchBarValue" :search-bar="`td`"/>
          <h3>{{$t('filter_interventions_title')}}</h3>
          <student-filter-container/>
        </div>
      </div>
      <div class="content-panel">
        <FilteredTable id="myStudentsPageFilter">
          <v-layout column slot="page-heading">
            <h1>{{$t('my_students')}}</h1>
            <custom-text msg="custom-text.students" class="mt-2 mb-1"></custom-text>
          </v-layout>
          <div slot="header" key="main-content" slot-scope="props">
            <v-layout row wrap>
              <v-flex v-if="$vuetify.breakpoint.smAndDown" xs12 sm5>
                <search-bar :placeholder="searchBarPlaceholder" :hint="searchBarHint"
                            search-action="SEARCH_LIST_OF_STUDENTS" :search-value="searchBarValue" :search-bar="`mt`"/>
              </v-flex>
              <v-flex xs12 sm6>
                <v-select id="students_sort"
                          attach
                          :items="sortFields"
                          v-model="sortBy" content-class="students_sort_menu"
                          :label="$t('select_sorting')">
                </v-select>
              </v-flex>

              <v-flex xs12 sm11 md6 text-xs-right align-self-center>
                <v-btn v-if="flagDisplayDownloadStudents"
                       :disabled="loading || (totalElements === 0) || report_downloading"
                       @click="downloadStudentReport"
                       outline class="mr-0 students_download" color="primary">
                  <v-icon left>file_download</v-icon>
                  {{$t(report_download_button_label)}}
                </v-btn>
                <div v-if="$vuetify.breakpoint.smAndUp || !props.isFixed" class="d-inline-block">
                  <div v-if="!loading" >{{$t(searchResultsKey, {count: totalElements}, totalElements)}}</div>
                </div>
              </v-flex>
            </v-layout>
            <v-progress-linear v-if="loading" height="2" :indeterminate="true" color="accent"></v-progress-linear>
          </div>
          <studenttable slot="table" class="students-table"></studenttable>
        </FilteredTable>
      </div>
    </div>
    <v-btn color="secondary" v-if="$vuetify.breakpoint.smAndDown" fab fixed bottom right secondary
           @click="openStudentsFilters"
           :class="{'nudge-fab-bottom': nudgeBottom}">
      <v-icon class="secondary-text">filter_list</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
  import Studenttable from './StudentTable.vue'
  import FilteredTable from '../FilteredTable'
  import { CHANGE_SORTING, DOWNLOAD_STUDENT_REPORT, GET_MY_STUDENT_COLUMNS } from '../../store/action-types'
  import { SET_INFORMATION_DISPLAYED_LIST } from '../../store/mutation-types'
  import { listNames } from '../../store/modules/information'
  import { mapState, mapGetters, mapActions } from 'vuex'
  import SearchBar from './SearchBar'
  import FilterButton from '../filter/FilterButton'
  import StudentFilterContainer from '../filter/StudentFilterContainer'
  import RightDrawer from '../../mixins/RightDrawer'
  import { components, componentTitles } from '../../store/modules/rightDrawer'
  import CustomText from '../help/CustomText'
  import { HAS_FEATURE_FLAG } from '../../store/getter-types'

  export default {
    components: {
      StudentFilterContainer,
      FilterButton,
      SearchBar,
      Studenttable,
      FilteredTable,
      CustomText
    },
    name: 'mystudentspage',
    mixins: [RightDrawer],
    mounted () {
      this.$store.commit(SET_INFORMATION_DISPLAYED_LIST, listNames.MY_STUDENTS)
    },
    computed: {
      ...mapState({
        stateSortFields: state => state.students.sortFields,
        totalElements: state => state.students.totalElements,
        loading: state => state.students.loading,
        searchBarValue: state => state.students.searchStringDisplay,
        filtersApplied: state => state.students.filtersApplied,
        nudgeBottom: state => state.undo.state,
        report_downloading: state => state.students.report_downloading,
        report_download_button_label: state => state.students.report_download_button_label,
        moduleStudent: state => state.profile.module.student,
        functionMyStudent: state => state.students.functions.myStudents,
        optionEnableDownloadStudent: state => state.students.options.enable.downloadStudent
      }),
      ...mapGetters({
        hasFeatureFlag: HAS_FEATURE_FLAG
      }),
      sortFields () {
        return this.stateSortFields.map(field => {
          return {
            'text': this.$t(field.text),
            'value': field.value
          }
        })
      },
      sortBy: {
        get () {
          return this.$store.state.students.sortBy
        },
        set (value) {
          this.$store.dispatch(CHANGE_SORTING, value)
        }
      },
      searchBarPlaceholder () {
        return this.$t('students.search.placeholder')
      },
      searchBarHint () {
        return this.$t('students.search.hint')
      },
      searchResultsKey () {
        return this.filtersApplied ? 'filtered_results' : 'results'
      },
      flagDisplayDownloadStudents () {
        return this.hasFeatureFlag(this.moduleStudent + '.' + this.functionMyStudent + '.' + this.optionEnableDownloadStudent)
      }
    },
    methods: {
      ...mapActions({
        downloadStudentReport: DOWNLOAD_STUDENT_REPORT,
        getMyStudentColumns: GET_MY_STUDENT_COLUMNS
      }),
      openStudentsFilters () {
        this.setDrawerComponent(components.STUDENT_FILTER)
        this.setDrawerComponentTitle(componentTitles.STUDENT_FILTER)
        this.setDrawerState(true)
      }
    },
    created () {
      this.getMyStudentColumns()
    }
  }
</script>

<style scoped>
  .progress-linear {
    margin: -5px 0 0;
  }

  .inline {
    display: flex;
  }

  .filter-panel-inner {
    position: -webkit-sticky;
    position: sticky;
    top: 64px;
  }

  .content-panel {
    flex: 10 10 0;
  }

  .filter-panel-outer {
    flex: 3 3 0;
  }

  .nudge-fab-bottom {
    margin-bottom: 60px;
  }
  @media (max-width: 960px) {
    .students_download {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/student/MyStudentsPage.vue